import * as React from 'react';
import i18n from 'src/resources/i18n';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuickModeContainer from '../../containers/QuickMode';

/**
 * QuickMode画面
 * @param props
 */
const QuickMode: React.FunctionComponent<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Rakunavi_Name')} />
			<QuickModeContainer />
		</>
	);
};

export default QuickMode;



// WEBPACK FOOTER //
// ./src/pages/quickMode/QuickMode.tsx